"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganisationStatus = void 0;
var OrganisationStatus;
(function (OrganisationStatus) {
    OrganisationStatus["TRIAL"] = "TRIAL";
    OrganisationStatus["ACTIVE"] = "ACTIVE";
    OrganisationStatus["INACTIVE"] = "INACTIVE";
})(OrganisationStatus = exports.OrganisationStatus || (exports.OrganisationStatus = {}));
